// extracted by mini-css-extract-plugin
export default {"irc":"Irc_irc__i7a9f"};